export default "__VITE_ASSET__9c5b0c66__"